module.exports = __webpack_public_path__ + "static/media/quiz.80cf765c.svg";